import React, { useState } from 'react';
import { RoleBindingDto } from '../../../api-client';
import { useUnassignRoleFromGroup } from './useUnassignRoleFromGroup';
import { useParams } from 'react-router-dom';
import { UseMutateFunction } from 'react-query';
import { AxiosResponse } from 'axios';
import { ErrorResponse } from '../../../common/types/errorRespose';

type UseUnassignRoleModalFacade = () => {
  groupRoleToDelete: false | RoleBindingDto;
  setGroupRoleToDelete: React.Dispatch<React.SetStateAction<false | RoleBindingDto>>;
  closeGroupRoleDeleteModal: () => void;
  unassignRole: UseMutateFunction<
    AxiosResponse<void>,
    ErrorResponse,
    { groupId: string; roleId: string; isCustom?: boolean }
  >;
  isUnassigning: boolean;
};

export const useUnassignRoleModalFacade: UseUnassignRoleModalFacade = () => {
  const { id } = useParams<{ id: string }>();
  const [groupRoleToDelete, setGroupRoleToDelete] = useState<false | RoleBindingDto>(false);

  const closeGroupRoleDeleteModal = () => setGroupRoleToDelete(false);

  const { unassignRole, isUnassigning } = useUnassignRoleFromGroup(id, closeGroupRoleDeleteModal);

  return {
    groupRoleToDelete,
    setGroupRoleToDelete,
    closeGroupRoleDeleteModal,
    unassignRole,
    isUnassigning,
  };
};
